module.exports = __webpack_public_path__ + "img/all-types-icon.4b12fc71.svg";